module.exports = __webpack_public_path__ + "assets/icons/ic_visibility_on_24px.svg";